<template>
  <v-container >
    <v-card flat>
      <v-card-title class="title subprimary">
        <span>Список статусов задач:</span>
        <v-spacer></v-spacer>
        <v-btn @click="opened_form = true" color="secondary" flat >
          <v-icon>add</v-icon>
          Добавить
        </v-btn>
      </v-card-title>
      <v-card-text class="pb-1 pt-1">
        <v-layout justify-center  wrap>
          <v-flex>
            <v-data-table
              :headers="headers"
              :items="items"
              class="elevation-1  "
              hide-actions
            >
              <template slot="items" slot-scope="props">
                <td class="text-xs-left">
                  {{props.item.name}}
                </td>

                <td class="text-xs-left">
                  <v-icon color="teal" v-if="props.item.start">done</v-icon>
                  <v-icon v-else>clear</v-icon>
                </td>
                <td class="text-xs-left">
                  <v-icon color="teal" v-if="props.item.allowed">done</v-icon>
                  <v-icon v-else>clear</v-icon>
                </td>
                <td class="text-xs-left">
                  <v-icon color="teal" v-if="props.item.rejected">done</v-icon>
                  <v-icon v-else>clear</v-icon>
                </td>
                <td class="text-xs-left">
                  <v-icon color="teal" v-if="props.item.require_motivation">done</v-icon>
                  <v-icon v-else>clear</v-icon>
                </td>
                <td class="justify-end text-xs-right" v-bind="selected">
                  <v-icon
                    @click="updateItem(props.item)"
                    class="mr-2"
                    medium

                  >
                    edit
                  </v-icon>
                  <v-icon
                    @click="openConfirmDelete(props.item)"
                    medium

                  >
                    delete
                  </v-icon>
                </td>
              </template>
              <template slot="no-data">
                <v-btn @click="getItems()" color="primary">Обновить</v-btn>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>

    <v-dialog @input="closedForm" persistent v-model="opened_form" width="500">
      <v-card>
        <v-toolbar color="primary" dark flat>
          <span v-if="!!selected.id">Изменить статус</span>
          <span v-else> <div><h3>Добавить статус</h3> </div></span>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-toolbar-items>
              <v-btn @click="closedForm" dark flat icon>
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar-items>
        </v-toolbar>
        <Status @addItem="addItem"
                    @refreshItem="refreshItem"
                    v-bind="selected"
                    v-if="opened_form"
        >
        </Status>
      </v-card>
    </v-dialog>


    <v-dialog persistent v-model="opened_confirm" width="500">
      <v-card v-if="deletable">
        <v-card-title>Подтвердите удаление</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          Вы уверены что хотите удалить статус из списка?<br>
        </v-card-text>
        <v-card-actions>
          <v-flex>
            <v-btn
              @click="deleteItem(deletable.id)"
              color="warning"
              flat
            >
              Удалить
            </v-btn>
            <v-btn
              @click="closeConfirmDelete"
              flat
            >Отмена
            </v-btn>
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>


<script>
  import Status from '@/modules/petition/forms/Status.vue'
  import UserDataMixin from '../../../../mixins/UserDataMixin'
  import urls from '../../urls'
  import {makeManagerUrl} from "../../../../helper";

  export default {
    name: "StatusList",
    components: {Status},
    mixins: [UserDataMixin],
    data: function () {


      return {

        headers: [
          {
            text: 'Статус задачи',
            sortable: false,
            value: 'name',
          },
          {
            text: 'Начальный',
            sortable: false,
            value: 'name',
          },
          {
            text: 'Принятый',
            sortable: false,
            value: 'name',
          },
          {
            text: 'Отклонен',
            sortable: false,
            value: 'name',
          },
          {
            text: 'Требует пояснений',
            sortable: false,
            value: 'name',
          },
          {text: 'Действия',
            sortable: false,
            align: 'right',},
        ],

        URL_LIST: makeManagerUrl(urls.getUrl('admin|petition|petition|status-list', 'list')),
        URL_DELETE: makeManagerUrl(urls.getUrl('admin|petition|petition|status-detail', 'destroy')),

      }
    },
    methods: {

      allowed(urlname, action) {
        return urls.getUrlAllowed(urlname, action)
      },
    },
    created() {

      this.getItems();

    },

  }

</script>

<style scoped>

</style>
